export const getDefaultState = () => {
  return {
    activeStep: 0,
    selectedField: null,
    defaultPriceMTAB: 19,
    fullPriceMTAB: 0,
    mTabIncludedApps: ['MTABAPPPHOTO'],
    priceFull: 0,
    price: 0,
    priceGreenPackage: 0,
    pricePremiumPackage: 0,
    pricesAfterMtab: {
      price: 0,
      priceGreenPackage: 0,
      greenDiscountFrom: 0,
      pricePremiumPackage: 0
    },
    numberFormatter: new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0 // (causes 2500.99 to be printed as $2,501)
    }),
    selectedPackage: '',
    selectedPackageData: {},
    litePackageDisabled: false,
    appHeight: null,
    navigationHeight: 140,
    visualBlockKey: 'vbk',
    visualBlockVisibleMobile: false,
    visualBlockNegativeMargin: 0,
    visualLineHeight: 0,
    configCode: '',
    configURL: '',
    configCodeSeparator: '-',
    extensionsModulesByID: {},
    applicationsByID: {},
    layoutsByID: {},
    accessoriesByID: {},
    selected: {
      extensionsModules: [],
      applications: [],
      layout: 'TABLETOP',
      accessories: []
    },
    preselected: {
      applications: [],
      accessories: [],
      accessoriesActive: []
    },
    allowed: {
      applications: [],
      accessories: []
    },
    disabled: {
      extensionsModules: [],
      layouts: ['TROLLEYECG']
    },
    snackbars: {
      selectionDisabled: false,
      selectionDisabledText: 'MESI just made your configuration better by deselecting unnecessary hardware! Get the same results using our Smart App.',
      general: false,
      generalSnackbarText: ''
    },
    dialogs: {
      selectionDisabled: false,
      disabledItemsBySelectingAnother: [],
      generic: false,
      termsConditions: false,
      faq: false,
      sendInquiry: false,
      share: false,
      thankYou: false,
      genericDialogContent: '',
      genericDialogLoading: false
    },
    steps: [
      {
        componentName: 'ExtModules',
        name: 'Diagnostic Tools',
        complete: false,
        visualStepHeight: null,
        assetsInteractivePath: '@/assets/extModules/interactive/',
        assetsVisualPath: '@/assets/extModules/visual/'
      },
      {
        componentName: 'Apps',
        name: 'Smart Applications',
        complete: false,
        visualStepHeight: null,
        assetsInteractivePath: '@/assets/apps/interactive/',
        assetsVisualPath: '@/assets/apps/visual/'
      },
      {
        componentName: 'Layout',
        name: 'Layout',
        complete: false,
        visualStepHeight: null,
        assetsInteractivePath: '@/assets/layout/interactive/',
        assetsVisualPath: '@/assets/layout/visual/'
      },
      {
        componentName: 'Accessories',
        name: 'Accessories',
        complete: false,
        visualStepHeight: null,
        assetsInteractivePath: '@/assets/accessories/interactive/',
        assetsVisualPath: '@/assets/accessories/visual/'
      },
      {
        componentName: 'Plan',
        name: 'Plan',
        complete: false,
        visualStepHeight: null
      }
    ]
  }
}
